import chunk from 'lodash.chunk';

import { projectsStardogRequestDispatchers } from 'src/actions/projects/actionCreators';
import { PROJECT_MODEL_LABEL_LIMIT } from 'src/constants/limits';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const requestProjectModelLabelsAndDescriptions =
  ({
    projectId,
    modelId,
    databaseId,
    namedGraphs,
    allIris,
  }: {
    projectId: string;
    modelId: string;
    databaseId: string;
    namedGraphs: string[];
    allIris: Set<string>;
  }) =>
  async (_dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const existingLabels = new Set(
      Object.keys(
        getState().projects.projectsById[projectId].modelsById[modelId]
          .labelsByIri || {}
      )
    );
    const missingLabels = Array.from(allIris).filter(
      (iri) => !existingLabels.has(iri)
    );

    if (missingLabels.length) {
      const chunks = chunk(missingLabels, PROJECT_MODEL_LABEL_LIMIT);
      await Promise.all(
        chunks.map((iris) =>
          projectsStardogRequestDispatchers.requestProjectModelLabelsAndDescriptions(
            {
              id: projectId,
              modelId,
              databaseId,
              namedGraphs,
              iris,
            }
          )
        )
      );
    }
  };
